<template>
  <v-container fluid class="pa-2 grid-list-md">
    <v-layout row wrap>
      <v-flex xs12 md9 class="mx-auto">
        <v-select
        v-model="lComp.comm_id"
        label="Community"
        :items="commList"
        item-text="comm_name"
        item-value="comm_id"
        placeholder="All"
        filled
        clearable
        @input="loadAllCompStats(lComp.comm_id)"
        ></v-select>
      </v-flex>
      <!-- Total Complaints Count -->
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6 sm4>
            <v-card @click="loadTotalCompList(lComp.comm_id)" :class="chosenCard === 'total' ? 'accent lighten-1' : ''">
              <v-card-title class="pa-2 title primary--text grey lighten-4">
                Total Complaints
              </v-card-title>
              <v-card-text class="black--text">
                <v-flex xs12>
                  <div class="text-center display-1">
                    {{ totComp }}
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-account</v-icon>{{ totPersComp }}
                    </v-flex>
                    <v-flex xs2 class="text-center">
                      <v-divider vertical></v-divider>
                    </v-flex>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-city</v-icon>{{ totComComp }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- Total Open Complaints Count -->
          <v-flex xs6 sm4>
            <v-card @click ="loadOpenCompList(lComp.comm_id)" :class="chosenCard === 'open' ? 'accent lighten-1' : ''">
              <v-card-title class="pa-2 title primary--text grey lighten-4">
                Open Complaints
              </v-card-title>
              <v-card-text class="black--text">
                <v-flex xs12>
                  <div class="text-center display-1">
                    {{ totOpen }}
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-account</v-icon>{{ totOpenPersComp }}
                    </v-flex>
                    <v-flex xs2 class="text-center">
                      <v-divider vertical></v-divider>
                    </v-flex>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-city</v-icon>{{ totOpenComComp}}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- Total SLA Complaints Count -->
          <v-flex xs6 sm4>
            <v-card @click ="loadSlaCompList(lComp.comm_id)" :class="chosenCard === 'slaBreached' ? 'accent lighten-1' : ''">
              <v-card-title class="pa-2 title primary--text grey lighten-4">
                SLA Breached
              </v-card-title>
              <v-card-text class="black--text">
                <v-flex xs12>
                  <div class="text-center display-1">
                    {{ totSla }}
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-account</v-icon> {{ totSlaPersComp }}
                    </v-flex>
                    <v-flex xs2 class="text-center">
                      <v-divider vertical></v-divider>
                    </v-flex>
                    <v-flex xs5 class="text-center title">
                      <v-icon large>mdi-city</v-icon> {{ totSlaComComp }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Total Complaints List -->
      <v-flex xs12 mx-auto class="pt-4" v-if="openComp.length>0">
        <v-layout row rap>
          <v-flex xs6>
            <v-text-field
            append-icon="mdi-account-search"
            :placeholder="$vuetify.breakpoint.smAndUp?'Search by Community Name, Complaint Number, etc.':'Search'"
            hide-details
            outlined
            clearable
            v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-download-as
            class="pt-1"
            :headers="compHeader"
            :items="openComp"
            title="Complaints List"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-layout>
        <v-data-table
        :headers="compHeader"
        :items="openComp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        :search="search"
        sort-by="comp_id"
        sort-desc
        class="elevation-3 mt-3">
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.comm_name }}</td>
            <td>{{ props.item.comp_id }}</td>
            <td>{{ handy.formatDBDate(props.item.comp_dt) }}</td>
            <td>{{ props.item.comp_severity }}</td>
            <td>{{ props.item.comp_cat }}</td>
            <td>{{ props.item.comp_title }}</td>
            <td>{{ props.item.cust_name }}</td>
            <td>{{ props.item.block_and_unit || 'NA' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <!-- Total Open Complaints List -->
    <v-flex xs12 mx-auto class="pt-4" v-if="totalComp.length>0">
      <v-layout row rap>
        <v-flex xs6>
          <v-text-field
          append-icon="mdi-account-search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by Community Name, Complaint Number, etc.':'Search'"
          hide-details
          v-model="search"
          outlined
          clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-download-as
          class="pt-1"
          :headers="compHeader"
          :items="totalComp"
          title="Complaints List"
          :landscape="true"
          ></v-download-as>
        </v-flex>
      </v-layout>
      <v-data-table
      :headers="compHeader"
      :items="totalComp"
      hide-default-footer
      :mobile-breakpoint="0"
      disable-pagination
      :search="search"
      sort-by="comp_id"
      sort-desc
      class="elevation-3 mt-3">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.comp_id }}</td>
          <td>{{ handy.formatDBDate(props.item.comp_dt) }}</td>
          <td>{{ props.item.comp_severity }}</td>
          <td>{{ props.item.comp_cat }}</td>
          <td>{{ props.item.comp_title }}</td>
          <td>{{ props.item.cust_name }}</td>
          <td>{{ props.item.block_and_unit || 'NA' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
  <!-- Total SLA Complaints List -->
  <v-flex xs12 mx-auto class="pt-4" v-if="slaComp.length>0">
    <v-layout row rap>
      <v-flex xs6>
        <v-text-field
        append-icon="mdi-account-search"
        :placeholder="$vuetify.breakpoint.smAndUp?'Search by Community Name, Complaint Number, etc.':'Search'"
        hide-details
        v-model="search"
        outlined
        clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-download-as
        class="pt-1"
        :headers="slaHeader"
        :items="slaComp"
        title="Complaints List"
        :landscape="true"
        ></v-download-as>
      </v-flex>
    </v-layout>
    <v-data-table
    :headers="slaHeader"
    :items="slaComp"
    hide-default-footer
    disable-pagination
    :mobile-breakpoint="0"
    :search="search"
    sort-by="sla_breached_by"
    sort-desc
    class="elevation-3 mt-3">
    <template slot="item" slot-scope="props">
      <tr>
        <td>{{ props.item.comm_name }}</td>
        <td>{{ props.item.comp_id }}</td>
        <td>{{ handy.formatDBDate(props.item.comp_dt) }}</td>
        <td>{{ props.item.comp_severity }}</td>
        <td>{{ props.item.comp_cat }}</td>
        <td>{{ props.item.comp_title }}</td>
        <td>{{ props.item.cust_name }}</td>
        <td>{{ props.item.block_and_unit || 'NA' }}</td>
        <td>{{ props.item.sla_breached_by }}</td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import VDownloadAs from './VDownloadAs.vue'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      config: config,
      handy: handy,
      rules: handy.rules,
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      // complaints
      slaComp: [],
      openComp: [],
      totalComp: [],
      compHeader: [
        { text: 'Community', value: 'comm_name' },
        { text: 'Comp. No.', value: 'comp_id' },
        { text: 'Date', value: 'comp_dt', width: '110px' },
        { text: 'Severity', value: 'comp_severity' },
        { text: 'Category', value: 'comp_cat' },
        { text: 'Title', value: 'comp_title' },
        { text: 'Raised By', value: 'cust_name' },
        { text: 'Unit', value: 'block_and_unit', width: '80px' },
      ],
      slaHeader: [
        { text: 'Community', value: 'comm_name' },
        { text: 'Comp. No.', value: 'comp_id'},
        { text: 'Date', value: 'comp_dt', width: '110px' },
        { text: 'Severity', value: 'comp_severity' },
        { text: 'Category', value: 'comp_cat' },
        { text: 'Title', value: 'comp_title' },
        { text: 'Raised By', value: 'cust_name' },
        { text: 'Unit', value: 'block_and_unit', width: '80px' },
        { text: 'Breached By', value: 'sla_breached_by', width: '140px'  }
      ],
      search: '',
      lComp: {},
      commList: [],
      totComp: '',
      totPersComp: '',
      totComComp: '',
      totOpen: '',
      totOpenPersComp: '',
      totOpenComComp: '',
      totSla: '',
      totSlaPersComp: '',
      totSlaComComp: '',
      chosenCard: '',
      total: '',
      open: '',
      slaBreached: ''
    }
  },
  mounted () {
    this.loadCommunity()
    this.loadSlaCompList()
    this.loadAllCompStats()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadAllCompStats (curCommId) {
      this.loadTotalCompStats(curCommId)
      this.loadOpenCompStats(curCommId)
      this.loadSlaCompStats (curCommId)
      this.loadSlaCompList(curCommId)
    },
    loadTotalCompStats (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
        }
      }
      this.axios.get(config.API_URL + '/getTotalCompStats/', qry)
      .then(response => {
        this.totPersComp = response.data[0].personal_comp
        this.totComComp = response.data[0].community_comp
        this.totComp = this.totPersComp + this.totComComp
        if (this.chosenCard === 'total') {
          this.loadTotalCompList(curCommId)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadOpenCompStats (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
          group_by: 'total_Open_Comp'
        }
      }
      this.axios.get(config.API_URL + '/getTotalCompStats/', qry)
      .then(response => {
        this.totOpenPersComp = response.data[0].personal_comp
        this.totOpenComComp = response.data[0].community_comp
        this.totOpen = this.totOpenPersComp + this.totOpenComComp
        if (this.chosenCard === 'open') {
          this.loadOpenCompList(curCommId)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSlaCompStats (curCommId) {
      var qry = {
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
          group_by: 'total_Sla_Comp'
        }
      }
      this.axios.get(config.API_URL + '/getTotalCompStats/', qry)
      .then(response => {
        this.totSlaPersComp = response.data[0].personal_comp
        this.totSlaComComp = response.data[0].community_comp
        this.totSla = this.totSlaPersComp + this.totSlaComComp
        if (this.chosenCard === 'slaBreached') {
          this.loadSlaCompList(curCommId)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadTotalCompList (curCommId) {
      this.chosenCard = 'total'
      var qry = {
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
          group_by: 'total_Comp_List'
        }
      }
      this.openComp = []
      this.slaComp = []
      this.axios.get(config.API_URL + '/getAllCompList/', qry)
      .then(response => {
        this.totalComp = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadOpenCompList (curCommId) {
      this.chosenCard ='open'
      var qry ={
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
          group_by: 'total_Open_Comp_List'
        }
      }
      this.totalComp = []
      this.slaComp = []
      this.axios.get(config.API_URL + '/getAllCompList/', qry)
      .then(response => {
        this.openComp = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadSlaCompList (curCommId) {
      this.chosenCard ='slaBreached'
      var qry ={
        params: {
          comm_id: curCommId,
          vendor_id: config.VENDOR_ID,
          group_by: 'total_Sla_Comp_List'
        }
      }
      this.openComp = []
      this.totalComp = []
      this.axios.get(config.API_URL + '/getAllCompList/', qry)
      .then(response => {
        this.slaComp = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.slaComp = []
      })
    }
  }
}
</script>
